/**
 * Dropdown Handlers for CardBody Component
 * Contains handlers for dropdown interactions
 */

/**
 * Toggle project status dropdown
 * @param {Function} setIsProjectStatusDropdownOpen - Setter for dropdown open state
 * @returns {Function} Toggle handler
 */
export const toggleProjectStatusDropdown = (setIsProjectStatusDropdownOpen) => {
  return () => {
    setIsProjectStatusDropdownOpen((prev) => !prev);
  };
};

/**
 * Toggle project status mobile dropdown
 * @param {Function} setIsProjectStatusMobileDropdownOpen - Setter for dropdown open state
 * @returns {Function} Toggle handler
 */
export const toggleProjectStatusMobileDropdown = (setIsProjectStatusMobileDropdownOpen) => {
  return () => {
    setIsProjectStatusMobileDropdownOpen((prev) => !prev);
  };
};

/**
 * Toggle project status merge dropdown
 * @param {Function} setIsProjectStatusMergeDropdownOpen - Setter for dropdown open state
 * @returns {Function} Toggle handler
 */
export const toggleProjectStatusMergeDropdown = (setIsProjectStatusMergeDropdownOpen) => {
  return () => {
    setIsProjectStatusMergeDropdownOpen((prev) => !prev);
  };
};

/**
 * Toggle project status mobile merge dropdown
 * @param {Function} setIsProjectStatusMobileMergeDropdownOpen - Setter for dropdown open state
 * @returns {Function} Toggle handler
 */
export const toggleProjectStatusMobileMergeDropdown = (setIsProjectStatusMobileMergeDropdownOpen) => {
  return () => {
    setIsProjectStatusMobileMergeDropdownOpen((prev) => !prev);
  };
};

/**
 * Handle dropdown toggle for actions menu
 * @param {Function} setActiveDropdownId - Setter for active dropdown ID
 * @returns {Function} Toggle handler
 */
export const handleDropdownToggle = (setActiveDropdownId) => {
  return (itemId) => {
    setActiveDropdownId((prevId) => (prevId === itemId ? null : itemId));
  };
};

/**
 * Handle project status change
 * @param {Function} setProjectStatusFilter - Setter for project status filter
 * @param {Function} setSelectedClients - Setter for selected clients
 * @returns {Function} Status change handler
 */
export const handleProjectStatusChange = (setProjectStatusFilter, setSelectedClients) => {
  return (status) => {
    setProjectStatusFilter(status);
    setSelectedClients(new Set());
  };
};

/**
 * Handle tag input change
 * @param {Function} setTagQuery - Setter for tag query
 * @returns {Function} Input change handler
 */
export const handleTagInputChange = (setTagQuery) => {
  return (event) => {
    setTagQuery(event.target.value);
  };
};

/**
 * Toggle group expansion
 * @param {Function} effectiveSetEditedId - Setter for edited ID
 * @param {Function} setExpandedGroups - Setter for expanded groups
 * @returns {Function} Toggle handler
 */
export const toggleGroup = (effectiveSetEditedId, setExpandedGroups) => {
  return (groupIndex) => {
    effectiveSetEditedId(null);
    setExpandedGroups((prevGroups) => {
      if (prevGroups.includes(groupIndex)) {
        // Group is expanded, so collapse it
        return prevGroups.filter((index) => index !== groupIndex);
      } else {
        // Group is collapsed, so expand it
        return [...prevGroups, groupIndex];
      }
    });
  };
};
